import React, {Fragment, useEffect, useMemo, useRef, useState} from 'react';
import Addresses from "./addresses.jsx";
import './styles.scss';
import DataBlock from "../../../components/DataBlock.jsx";
import Section from "../../../components/Section.jsx";
import ParcelParamsBlock from "./parcelParamsBlock.jsx";
import {Button, Checkbox, Dimmer, Form, FormField, Input, Loader as Load, Radio, Segment} from "semantic-ui-react";
import CardBlock from "../../../components/CardBlock.jsx";
import Info from "../../../components/Info.jsx";
import DatePicker from "../../../components/DatePicker/DatePicker.jsx";
import Dropdown from "../../../components/Dropdown.jsx";
import uuidv4 from "uuid/v4";
import {apiGet, apiPost, apiPut} from "../../../services/apiClient";
import {
    getCurrentUserCompanyId,
    getCurrentUserId,
    getCurrentUserSubCompanyId,
    getRoles
} from "../../../services/userRights";
import ConfirmModal from "../../../components/Modals/ConfirmModal.jsx";
import ru from 'react-phone-input-2/lang/ru.json';
import i18n from "../../../services/i18n";
import Logos from "./logos.jsx";
import throttle from "lodash.throttle";
import '../../../containers/style/styles.scss';
import {toast} from 'react-toastify';
import {parseDate} from "../../../services/date";
import {costFormat} from "../../../services/cost";
import PointAddress from "./pointAddress";
import InfoSection from "./infoSection";
import CalcByPlaces from "./calcByPlaces";
import DocParams from "./docParams";
import TotalBlock from "./totalBlock";
import {calcWeight} from "./math";
import TotalVolumeAndWeight from "./totalVolumeAndWeight";
import {findPhoneNumbersInText} from 'libphonenumber-js';
import moment from 'moment';
import ResultData from "./resultData";
import {customMatchingServices, formServicesArray, returnOfAccompanyingDocumentsName, returnParcelName} from "./utils";
import Loader from "../../../components/Loader/Loader";
import {containsAnyLetter, onBeforeUnloadOff, onBeforeUnloadOn} from "../../../services/utils";
import SetCompanyBlock from "./setCompanyBlock";
import PayerTab from "./tabs/payerTab";
import LineLoader from "../../../components/Loader/LineLoader";
import {Prompt} from "react-router";
import BannerCalc from "./bannerCalc";
import PalletsForm from "./palletsForm";

const ParamsStep = ({
                        total,
                        isDoc = false,
                        isPallets = false,
                        changeParam,
                        form,
                        onClick,
                        errors,
                        calcByPlacesOn,
                        setCalcByPlacesOn,
                        companyData,
                        initData
                    }) => {
    const cargoDescriptionField = <FormField error={errors['cargoDescription']}>
        <label>
            Описание содержимого*
            <Info
                name={'Описание содержимого'}
                text={
                    <div>
                        Полный перечень запрещенных к перевозке предметов указан <a target='_blank'
                                                                                    href={(companyData && companyData.publicOfferUrl) || ''}>в
                        публичной оферте</a>, а также будет указан на сайте ТК после ее выбора
                    </div>
                }/>
        </label>
        <Input
            maxLength={255}
            name='cargoDescription'
            value={form.cargoDescription || ''}
            onChange={(e, {name, value}) => changeParam(name, value)} placeholder={'НАПРИМЕР, ЦЕННЫЙ ГРУЗ'}
        />
    </FormField>

    const changeParamPallet = (name, value) => {
        if (name === 'palletsCount') {
            if (!form.isChangedPalletsData) {
                changeParam('palletsVolume', value * initData.palletsVolume);
                changeParam('palletsWeight', value * initData.palletsWeight);
            }
        } else {
            changeParam('isChangedPalletsData', true);
        }
        changeParam(name, value);
    }

    return <ParcelParamsBlock
        footerContent={total}
        onClick={onClick}
    >
        <Form>
            {(!isDoc && !isPallets) && <Fragment>
                <TotalVolumeAndWeight
                    form={form}
                    changeParam={changeParam}
                    errors={errors}
                    isOff={calcByPlacesOn}
                    onCalcByPlaces={(d) => {
                        setCalcByPlacesOn(d);
                        changeParam('positions', !d ? null : [{cargoPackages: 1}]);
                    }}
                />
                {calcByPlacesOn && <CalcByPlaces
                    isCreate
                    positions={form.positions || [{cargoPackages: 1}]}
                    changeParam={changeParam}
                    errors={errors}
                />}
            </Fragment>}

            {isPallets && <Fragment>
                <PalletsForm
                    form={form}
                    changeParam={changeParamPallet}
                    errors={errors}
                />
            </Fragment>}

            {isDoc && <DocParams
                form={form}
                changeParam={changeParam}
                errors={errors}
                field={cargoDescriptionField}
            />}

            {!isDoc && cargoDescriptionField}
        </Form>
    </ParcelParamsBlock>;
}

const addressName = (address) => {
    return !address ? '' : `${address.city ? `${address.city}` : ''}`;
}

const ResultStepSettingsBlock = ({label, children}) => {
    return (
        <div className='setting'>
            <h3>
                {label}
            </h3>
            {children}
        </div>
    );
}

const compareDates = (date1, date2) => {
    const date1format = "" + date1.getDate() + date1.getMonth() + date1.getFullYear();
    const date2format = "" + date2.getDate() + date2.getMonth() + date2.getFullYear();
    return date1format === date2format;
}

const filterSortOptions = [
    {
        key: 'cost',
        value: 'cost',
        text: 'Тариф'
    },
    {
        key: 'deliveryTime',
        value: 'deliveryTime',
        text: 'Ожидаемая дата доставки'
    },
    {
        key: 'carrierName',
        value: 'carrierName',
        text: 'Перевозчик'
    },
    {
        key: 'departureDate',
        value: 'departureDate',
        text: 'Забор груза'
    },
    {
        key: 'maxDays',
        value: 'maxDays',
        text: 'В пути'
    },
]

const ResultFilter = ({form, changeParam, sortBy, setSortBy, isCalc, weekdays}) => {

    return <Form className='result-filter'>
        <Form.Field>
            <label>
                Забор груза
            </label>
            <DatePicker
                excludeDates={weekdays.map(w => new Date(w))}
                minDate={new Date()}
                name='departureDate'
                className={compareDates(form.departureDate, new Date()) ? 'bold-input' : ''}
                dateFormat='dd.MM.yyyy'
                placeholderText='дд.мм.гггг'
                value={form.departureDate}
                valueText={compareDates(form.departureDate, new Date()) ? 'Сегодня' : null}
                onChange={(e, {value}) => changeParam('departureDate', value)}
            />
        </Form.Field>

        <Form.Field>
            <label>
                Сортировать по:
            </label>
            <Dropdown
                name='sortBy'
                value={sortBy}
                onChange={(e, {name, value}) => setSortBy(value)}
                options={filterSortOptions.filter(o => !isCalc || o.key !== 'carrierName')}
            />
        </Form.Field>
    </Form>
}

const allTariffServicesCodes = (tariffs) => {
    let codes = [];
    tariffs.forEach(t => (t.services || []).forEach(s => {
        !codes.includes(s.code) && codes.push(s.code);
    }));
    return codes;
}

const ResultStep = ({
                        total,
                        tariffs = [],
                        loading,
                        deliveryTypes = [],
                        services = [],
                        form,
                        changeParam,
                        setStep,
                        onClick,
                        isCalc = false,
                        isCalcV2 = false,
                        weekdays,
                        saveDraftBtn
                    }) => {

    const [sortBy, setSortBy] = useState(filterSortOptions[0].value);

    const changeFilter = (name, value) => {
        changeParam(name, value);
    }

    useEffect(() => {
        form.departureDate && onClick();
    }, [form.departureDate]);

    const filterByServices = (tariffs = []) => {
        return tariffs.filter(tariff => {
            const serviceCodes = (tariff.services || []).map(s => s.code);
            const services = formServicesArray(form);
            return services.every(s => serviceCodes.includes(s) || serviceCodes.find(sc => customMatchingServices(s, sc, tariff.carrierCode)));
        })
    }

    const sortTariffs = (tariffs) => {

        return filterByServices(tariffs).sort(function (a, b) {
            if (sortBy === 'deliveryTime') {
                if ((!a['minDeliveryTime'] && !a['minDeliveryTime']) && !(!b['minDeliveryTime'] && !b['minDeliveryTime'])) return 1;
                if (!(!a['minDeliveryTime'] && !a['minDeliveryTime']) && (!b['minDeliveryTime'] && !b['minDeliveryTime'])) return -1;
                if (parseDate(a['minDeliveryTime']) > parseDate(b['minDeliveryTime'])) return 1;
                if (parseDate(a['minDeliveryTime']) < parseDate(b['minDeliveryTime'])) return -1;
                if (parseDate(a['maxDeliveryTime']) > parseDate(b['maxDeliveryTime'])) return 1;
                if (parseDate(a['maxDeliveryTime']) < parseDate(b['maxDeliveryTime'])) return -1;
            } else {
                if (a.displayData[sortBy] > b.displayData[sortBy]) {
                    return 1;
                }
                if (a.displayData[sortBy] < b.displayData[sortBy]) {
                    return -1;
                }
            }
            return 0;
        })
    }

    const setServices = (name, value) => {
        const s = form.services || {};
        const newServices = {
            ...s,
            [name]: value
        };
        if (name === returnOfAccompanyingDocumentsName && newServices[returnParcelName]) {
            newServices[returnParcelName] = false;
        }
        if (name === returnParcelName && newServices[returnOfAccompanyingDocumentsName]) {
            newServices[returnOfAccompanyingDocumentsName] = false;
        }
        changeParam('services', newServices);
    }

    const availableServices = services.filter(service => allTariffServicesCodes(tariffs).includes(service.value))

    return (
        <DataBlock
            label={loading ? 'Идет загрузка предложений...' : 'Результаты поиска'}
            maxSize
        >
            <LineLoader active={loading}/>
            <Section
                footerContent={total}
            />
            <div className='result-step'>
                <div className='result-step__table'>
                    <ResultFilter
                        weekdays={weekdays}
                        form={form}
                        changeParam={changeFilter}
                        setSortBy={setSortBy}
                        sortBy={sortBy}
                        isCalc={isCalc}
                    />
                    <ResultData
                        loading={tariffs.length < 1 && loading}
                        tariffs={sortTariffs(tariffs)}
                        form={form}
                        setStep={setStep}
                        changeParam={changeParam}
                        isCalc={isCalc}
                        isCalcV2={isCalcV2}
                    />
                </div>

                <div className='result-step__settings'>
                    <CardBlock>
                        <ResultStepSettingsBlock label={'Условия доставки'}>
                            {
                                deliveryTypes.map(dT => (
                                    <Form.Field key={dT.label} className='result-step__item'
                                                disabled={!dT.hasIntegration}>
                                        {dT.hasIntegration && <Radio
                                            checked={form.deliveryType === dT.value}
                                            label={dT.label}
                                            onChange={() => {
                                                changeParam('deliveryType', dT.value)
                                            }}
                                        />}
                                    </Form.Field>
                                ))
                            }
                        </ResultStepSettingsBlock>

                        {availableServices.length ? <ResultStepSettingsBlock label={'Услуги'}>
                            {
                                availableServices.map(s => (
                                    <Form.Field key={s.name} className='result-step__item'>
                                        <Checkbox
                                            checked={formServicesArray(form).includes(s.value)}
                                            onChange={(e, data) => setServices(s.value, data.checked)}
                                        />
                                        <div className='checkbox-label'>
                                            {s.name}
                                            {s.info && <Info
                                                name={s.name}
                                                text={s.info}
                                                position={'right'}
                                                offset={[10]}
                                            />}
                                        </div>

                                    </Form.Field>
                                ))
                            }
                        </ResultStepSettingsBlock> : null}
                    </CardBlock>
                    {saveDraftBtn && saveDraftBtn}
                    {
                        isCalc && <Button
                            className='modal__btn-cancel m-t-16 btn_light-blue btn__pooling'
                            onClick={() => window.open(`https://pooling.me/${isCalcV2 ? 'contactuscalc' : 'contactwithus'}`)}
                        >
                            <b>Подключиться к Pooling</b>
                        </Button>
                    }
                    {
                        isCalc && <BannerCalc/>
                    }
                </div>
            </div>
        </DataBlock>
    )
}

const CreateStep = (
    {
        form = {},
        changeForm: onChangeForm,
        changeParams,
        companyId,
        resetData,
        total,
        companyData,
        deliveryTypes,
        setStep,
        onChangeAddress,
        createParcel,
        errors,
        loading,
        loadingTariffs,
        services,
        parcelTypes,
        weekdays,
        saveDraftBtn,
        setErrors,
        valueDeclaredDisabled,
        insuranceCostIsNull
    }) => {

    const [dateChanged, setDateChanged] = useState(false);
    const [payerTabVisible, setPayerTabVisible] = useState(false);

    const changeForm = (name, value) => {
        if (name === 'isValueDeclared' && insuranceCostIsNull && !!value) {
            toast.info("Стоимость страхования будет рассчитана перевозчиком после создания отправления");
        }
        name === 'departureDate' && setDateChanged(true);
        onChangeForm(name, value);
    }

    const isDoc = form.parcelType === parcelTypes.parcelTypeDoc;

    const payerRef = useRef();

    useEffect(() => {
        payerRef.current.reloadReferences(companyData).then(a => {
                let payerTabVisible = a[2] || false;
                setPayerTabVisible(payerTabVisible);
                changeForm('payerTabVisible', payerTabVisible)
            }
        );
    }, [payerRef]);

    const payerTabChange = (newFieldValues) => {
        return new Promise((resolve) => {
            let parcel = form;
            newFieldValues.map((field) => {
                parcel[field.name] = field.value;
            });
            changeParams(parcel);
            resolve();
        });
    }

    useEffect(() => {
        setPayerErrors();
    }, [form]);

    const setPayerErrors = () => {
        const errs = payerRef.current.validateForm();
        return setErrors(errs);
    }

    return (
        <DataBlock
            label={'Создать отправление'}
            maxSize
        >
            <div className='result-step'>
                <div className='result-step__table'>
                    <PointAddress
                        isFrom
                        form={form}
                        changeForm={changeForm}
                        companyId={companyId}
                        changeParams={changeParams}
                        onChangeAddress={onChangeAddress}
                        errors={errors}
                        isCreate
                    />

                    <PointAddress
                        form={form}
                        changeForm={changeForm}
                        companyId={companyId}
                        changeParams={changeParams}
                        onChangeAddress={onChangeAddress}
                        errors={errors}
                        isCreate
                    />

                    <span style={{display: !payerTabVisible ? 'none' : 'block'}}>
                        <PayerTab
                            ref={payerRef}
                            parcel={form}
                            errors={errors}
                            isNew
                            isBusy={loading}
                            onFieldChange={payerTabChange}
                        />
                    </span>

                    <InfoSection
                        weekdays={weekdays}
                        temperatureRegime={formServicesArray(form).includes('temperatureRegime')}
                        resetData={resetData}
                        total={total}
                        form={form}
                        changeForm={changeForm}
                        companyData={companyData}
                        errors={errors}
                        isDoc={isDoc}
                        isCreate
                        valueDeclaredDisabled={valueDeclaredDisabled}
                    />

                    <div className='step-btn-block m-t-25'>
                        <Button
                            disabled={loading || (loadingTariffs && dateChanged) || form.saveDisabled}
                            className='step-btn-block__btn step-btn-block__btn_final' color={'blue'}
                            onClick={() => createParcel()}
                            id='opacity1'
                        >
                            {
                                loading || (loadingTariffs && dateChanged) ?
                                    <div className='step-btn-block__loader'>
                                        <div>{loading ? 'Загрузка данных в систему' : 'Обновление тарифа'}</div>
                                        <Segment vertical>
                                            <Load inverted active size='tiny'/>
                                        </Segment>
                                    </div>
                                    : 'Заказать отправление'
                            }
                        </Button>
                    </div>
                    <div className='step-btn-block m-t-16'>
                        <div className='personal-data'>
                            Нажимая кнопку «Заказать отправление», я соглашаюсь <a target='_blank'
                                                                                   href={companyData.publicOfferUrl || ''}>с
                            условиями публичной оферты, работы
                            курьерских служб</a> и даю согласие на обработку персональных данных.
                        </div>
                    </div>
                    <div className='step-btn-block m-t-7'>
                        <div className='personal-data'>
                            <a href='/'>Отменить</a>
                        </div>
                    </div>
                </div>

                <div className='result-step__settings'>
                    <CostCalcBlock form={form} deliveryTypes={deliveryTypes} services={services}
                                   parcelTypes={parcelTypes}/>
                    <Info
                        trigger={<Button className='modal__btn-cancel' onClick={() => {
                            setStep(3);
                        }}>
                            Выбрать другой тариф
                        </Button>}
                        text={'Введенные Вами данные будут сохранены при выборе другой транспортной компании'}
                    />
                    {saveDraftBtn && saveDraftBtn}
                </div>
            </div>
        </DataBlock>
    )
}

const CostCalcBlock = ({form, deliveryTypes, services = [], parcelTypes}) => {

    const isDoc = form.parcelType === parcelTypes.parcelTypeDoc;
    const isPallets = form.parcelType === parcelTypes.parcelTypePallets;

    return <div className='cost-calc'>
        <div className='cost-calc__background'>
            <div className='cost-calc__label'>
                Предварительный расчет
            </div>
            <div className='cost-calc__points'>
                <div className='cost-calc__params'>
                    <div className='cost-calc__carrier'>
                        <Logos
                            name={(form.selectedTariff || {}).carrierCode}
                        />
                        <Info
                            name={(form.selectedTariff || {}).carrierName}
                            label={(form.selectedTariff || {}).carrierServiceName}
                            position={'right'}
                            offset={[7]}
                        />
                    </div>
                </div>
                <div className='cost-calc__point'>
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.60003 14C5.60003 14 11.2 8.09251 11.2 5.21332C11.2 2.33409 8.69282 0 5.60003 0C2.50723 0 0 2.33409 0 5.21329C0 8.09249 5.60003 14 5.60003 14Z"
                            fill="#99D402"/>
                        <path
                            d="M5.60006 8.75C6.47525 8.75 7.27542 8.42877 7.88908 7.89778C8.63079 7.256 9.10006 6.3078 9.10006 5.25C9.10006 3.317 7.53305 1.75 5.60006 1.75C3.66706 1.75 2.10006 3.317 2.10006 5.25C2.10006 7.183 3.66706 8.75 5.60006 8.75Z"
                            fill="white"/>
                    </svg>
                    <div>
                        {addressName(form.shipmentAddress)}
                    </div>
                </div>
                <div className='cost-calc__point'>
                    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M5.60003 14C5.60003 14 11.2 8.09251 11.2 5.21332C11.2 2.33409 8.69282 0 5.60003 0C2.50723 0 0 2.33409 0 5.21329C0 8.09249 5.60003 14 5.60003 14Z"
                            fill="#459EFF"/>
                        <path
                            d="M5.60006 8.75C6.47525 8.75 7.27542 8.42877 7.88908 7.89778C8.63079 7.256 9.10006 6.3078 9.10006 5.25C9.10006 3.317 7.53305 1.75 5.60006 1.75C3.66706 1.75 2.10006 3.317 2.10006 5.25C2.10006 7.183 3.66706 8.75 5.60006 8.75Z"
                            fill="white"/>
                    </svg>
                    <div>
                        {addressName(form.deliveryAddress)}
                    </div>
                </div>
                <div className='cost-calc__params'>
                    {!isDoc ? 'Груз' : 'Документы'}, {((deliveryTypes || []).find(dt => dt.value === form.deliveryType) || {}).label}
                </div>
                <div className='cost-calc__params'>
                    {!isDoc && <div className='cost-calc__param'>
                        <div>
                            Кол-во мест:
                        </div>
                        <div className='cost-calc__value'>
                            {(form || {}).cargoPackages || 0}
                        </div>
                    </div>}
                    {!isDoc && <div className='cost-calc__param'>
                        <div>
                            Общий объем:
                        </div>
                        <div className='cost-calc__value'>
                            {(form || {}).cargoVolume || 0} м³
                        </div>
                    </div>}
                    <div className='cost-calc__param'>
                        <div>
                            Общий вес:
                        </div>
                        <div className='cost-calc__value'>
                            {isDoc ? ((form || {}).documentWeight || 0) : (form || {}).cargoWeight || 0} кг
                        </div>
                    </div>
                    {!isDoc && !isPallets && <div className='cost-calc__param'>
                        <div>
                            Объемный вес:
                        </div>
                        <div className='cost-calc__value'>
                            {calcWeight(form)} кг
                        </div>
                    </div>}
                </div>
                <div className='cost-calc__params'>
                    <div className='cost-calc__param'>
                        <div>
                            Стоимость отправки
                        </div>
                        <div className='cost-calc__value'>
                            {((form.selectedTariff && form.selectedTariff.cost) || 0).toFixed(2)} ₽
                        </div>
                    </div>
                    {
                        formServicesArray(form).map(s => {
                            const service = services.find(sf => sf.value === s);
                            return (<div className='cost-calc__param'>
                                <div>
                                    {service.name}
                                </div>
                                <div className='cost-calc__value cost-calc__value_green'>
                                    +{serviceTariff(s, form).cost || 0} ₽
                                </div>
                            </div>)
                        })
                    }
                    {form.selectedTariff && form.selectedTariff.serviceFee && <div className='cost-calc__param'>
                        <div>
                            Сервисный сбор
                        </div>
                        <div className='cost-calc__value cost-calc__value_green'>
                            +{form.selectedTariff.serviceFee} ₽
                        </div>
                    </div>
                    }
                    {form.isValueDeclared && <div className='cost-calc__param'>
                        <div>
                            Страхование
                        </div>
                        <div className='cost-calc__value cost-calc__value_green'>
                            +{form.insuranceCost || 0} ₽
                        </div>
                    </div>}
                </div>
                <div className='cost-calc__total'>
                    {costFormat(calcSum(form))} ₽
                </div>
            </div>
        </div>
    </div>
}

const Step = ({
                  step,
                  form,
                  changeForm,
                  changeParams,
                  onClick,
                  tariffs,
                  loading,
                  loadingCreate,
                  deliveryTypes,
                  setStep,
                  companyId,
                  resetData,
                  companyData,
                  onChangeAddress,
                  createParcel,
                  services,
                  errors,
                  parcelTypes,
                  isCalc = false,
                  isCalcV2 = false,
                  calcByPlacesOn,
                  setCalcByPlacesOn,
                  weekdays,
                  saveDraftBtn,
                  setErrors,
                  initData,
                  getValueDeclaredDisabled,
                  insuranceCostIsNull
              }) => {
    const valueDeclaredDisabled = useMemo(() => getValueDeclaredDisabled(form, parcelTypes), [form, parcelTypes]);

    switch (step) {
        case parcelTypes.parcelTypeCargo:
            return <ParamsStep
                companyData={companyData}
                calcByPlacesOn={calcByPlacesOn}
                setCalcByPlacesOn={setCalcByPlacesOn}
                form={form}
                changeParam={changeForm}
                total={<TotalBlock calcByPlacesOn={calcByPlacesOn} resetData={resetData} form={form}/>}
                onClick={() => onClick(true)}
                errors={errors}
            />;
        case parcelTypes.parcelTypeDoc:
            return <ParamsStep
                companyData={companyData}
                form={form}
                changeParam={changeForm}
                total={<TotalBlock resetData={resetData} form={form} isDoc/>}
                onClick={() => onClick(true)}
                errors={errors}
                isDoc
            />;
        case parcelTypes.parcelTypePallets:
            return <ParamsStep
                companyData={companyData}
                form={form}
                changeParam={changeForm}
                total={<TotalBlock resetData={resetData} form={form} isPallets/>}
                onClick={() => onClick(true)}
                errors={errors}
                isPallets
                initData={initData}
            />;
        case 3:
            return <ResultStep
                weekdays={weekdays}
                deliveryTypes={deliveryTypes}
                services={services}
                form={form}
                changeParam={changeForm}
                onClick={onClick}
                total={<TotalBlock
                    resetData={resetData}
                    form={form}
                    isPallets={form.parcelType === parcelTypes.parcelTypePallets}
                    isDoc={form.parcelType === parcelTypes.parcelTypeDoc}
                    isResult
                />}
                tariffs={tariffs}
                loading={loading}
                setStep={setStep}
                errors={errors}
                isCalc={isCalc}
                isCalcV2={isCalcV2}
                saveDraftBtn={saveDraftBtn}
            />;
        case 4:
            return <CreateStep
                weekdays={weekdays}
                form={form}
                changeForm={changeForm}
                changeParams={changeParams}
                companyId={companyId}
                resetData={resetData}
                total={<TotalBlock resetData={resetData} form={form}
                                   isDoc={form.parcelType === parcelTypes.parcelTypeDoc}/>}
                companyData={companyData}
                deliveryTypes={deliveryTypes}
                setStep={setStep}
                onChangeAddress={onChangeAddress}
                createParcel={createParcel}
                errors={errors}
                loading={loadingCreate}
                loadingTariffs={loading}
                services={services}
                parcelTypes={parcelTypes}
                saveDraftBtn={saveDraftBtn}
                setErrors={setErrors}
                valueDeclaredDisabled={valueDeclaredDisabled}
                insuranceCostIsNull={insuranceCostIsNull}
            />;
        default:
            return null;
    }
}

const serviceTariff = (s, form) => {
    return (form.selectedTariff.services || []).find(sT => sT.code === s) || {};
}

const calcSum = (form) => {
    let sum = (form.selectedTariff && form.selectedTariff.cost) || 0;

    if (form.selectedTariff && form.selectedTariff.serviceFee) sum += form.selectedTariff.serviceFee;

    if (form.isValueDeclared) sum += (form.insuranceCost || 0);
    formServicesArray(form).forEach(s => {
        sum += Number.parseFloat(serviceTariff(s, form).cost);
    })
    return sum;
}

const CreateParcelForm = ({history, match, isCalc = false, isCalcV2 = false}) => {

    i18n.changeLanguage('ru');

    let copyId = match && match.params && match.params.copyId;
    let draftId = match && match.params && match.params.draftId;
    let subCompanyId = getCurrentUserSubCompanyId();
    let isCoordinator = (getRoles() || []).includes('Coordinator');
    const [companyId, setCompanyId] = useState(getCurrentUserCompanyId())

    const [companyData, setCompanyData] = useState({});

    const loadCompanyData = () => {
        changeParamsForm({ companyId });

        apiGet('parcels/ref/companies/' + companyId)
            .then(data => {
                setCompanyData(data);
            })
            .catch(err => {
                console.log(err);
            });
    }

    useEffect(() => {
        !isCalc && companyId && loadCompanyData();
        (!isCalc && isCoordinator && !companyId) && setStep(-1);
    }, [companyId]);

    //step -1: Ввод ЮЛ
    //step 0: Ввод точек и типа груза
    //step 1: Параметры отправления - Документы
    //step 2: Параметры отправления - Груз
    //step 22: Параметры отправления - Паллеты
    //step 3: Результаты поиска
    //step 4: Создать отправление
    const [step, setStep] = useState(0);

    const [errors, setErrors] = useState(null);
    const [payerTabErrors, setPayerTabErrors] = useState(null);

    const [tariffs, setTariffs] = useState(null);

    const [deliveryTypes, setDeliveryTypes] = useState([]);
    const [services, setServices] = useState([]);

    const [confirmModal, setConfirmModal] = useState(false);

    const [loadingTariffs, setLoadingTariffs] = useState(false);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [loadingDraftSave, setLoadingDraftSave] = useState(false);
    const [isSaved, setIsSaved] = useState(false);

    const [syncTariffDeparture, setSyncTariffDeparture] = useState(false);

    const [parcelTypes, setParcelTypes] = useState({
        parcelTypeDoc: 1,
        parcelTypeCargo: 2,
        parcelTypePallets: 22
    });

    const [calcByPlacesOn, setCalcByPlacesOn] = useState(false);

    const initCountryCode = 'RU';

    const initForm = {
        sessionKey: uuidv4(),
        parcelType: null,

        shipmentCity: {
            // countryCode: initCountryCode
        },
        deliveryCity: {
            // countryCode: initCountryCode
        },

        shipmentAddress: {
            // countryCode: initCountryCode
        },

        deliveryAddress: {
            // countryCode: initCountryCode
        },

        // shipmentCountryCode: initCountryCode,

        // deliveryCountryCode: initCountryCode,

        departureDate: new Date(),
        palletsCount: 1,
        palletsVolume: 1.5,
        palletsWeight: 400,
        cargoWeight: 0.1,
        documentWeight: 0.2,
        cargoVolume: 0.0015,
        documentVolume: 0.0015,
        cargoPackages: 1,
        tariffs: null,
        selectedTariff: null,
        canEditFromAddress: true,
        canEditToAddress: true,
        positions: null,

        fromAddressCountry: null,
        fromAddressId: null,
        fromAddressName: null,
        originFromCityName: null,

        foAddressCountry: null,
        toAddressId: null,
        toAddressName: null,
        originToCityName: null,

        parcelId: null,
        vehicleTypeId: null,
        carrierPublicOfferUrl: null,

        declaredCargoValue: 300,

        tempConditionHigh: null,
        tempConditionLow: null,

        isValueDeclared: true,

        companyId: getCurrentUserCompanyId()
    };

    const [form, setForm] = useState(initForm);

    const getLastCountries = () => {
        apiPost('parcels/addresses/lastCountries').then(d => {
            changeParamsForm({
                shipmentCountryCode: d.shipmentCodeCountry || initCountryCode,
                deliveryCountryCode: d.deliveryCodeCountry || initCountryCode,
            })
        }).catch(e => console.log(e));
    }

    useEffect(() => {
        if (form.parcelType && (form.shipmentAddress.postalCode || form.shipmentAddress.estimatedPostalCode) && (form.deliveryAddress.postalCode || form.deliveryAddress.estimatedPostalCode)) {
            setStep(form.parcelType);
        };
    }, [form.parcelType, form.shipmentCity.fullName, form.deliveryCity.fullName]);

    const calcInsuranceCost = throttle(() => {
        apiPost('parcels/insurance', {
            parcelType: form.parcelType,
            declaredCargoValue: form.declaredCargoValue,
            isNoDeclaredValueConfirmation: form.isNoDeclaredValueConfirmation
        })
            .then(response => {
                changeForm('insuranceCost', response.value);
                setErrors(errors => ({
                    ...errors,
                    declaredCargoValue: response.value === null ? 'Неверная сумма' : null
                }))
            });
    }, 300);

    const getValueDeclaredDisabled = (form, parcelTypes) => {
        return form.selectedTariff && (form.parcelType === parcelTypes.parcelTypeDoc && ['CDEK'].includes(form.selectedTariff.carrierCode) && form.selectedTariff.isClientCarrier)
    }

    const insuranceCostIsNull = useMemo(() => {
        const valueDeclaredDisabled = getValueDeclaredDisabled(form, parcelTypes);
        return !valueDeclaredDisabled && form.selectedTariff && form.selectedTariff.isClientCarrier;
    }, [form.selectedTariff, form.parcelType])

    useEffect(() => {
        const valueDeclaredDisabled = getValueDeclaredDisabled(form, parcelTypes);

        if (valueDeclaredDisabled || (form.selectedTariff && form.selectedTariff.serviceFee)) {
            changeForm('isValueDeclared', false);
        }

        setSyncTariffDeparture(true);
    }, [form.selectedTariff]);

    useEffect(() => {
        if (syncTariffDeparture) {
            if (form.selectedTariff && form.selectedTariff.departureDate) {
                changeForm('departureDate', new Date(form.selectedTariff.departureDate));
            } else {
                setSyncTariffDeparture(false);
            }
        }
    }, [syncTariffDeparture]);

    useEffect(() => {
        if (syncTariffDeparture) {
            setSyncTariffDeparture(false);
        }
        else if (form.departureDate && step === 4) {
            updateTariffData();
        }
    }, [form.departureDate]);

    useEffect(() => {
        if (form.isValueDeclared && !insuranceCostIsNull) {
            calcInsuranceCost();
        } else {
            changeForm('insuranceCost', 0);
        }
    }, [insuranceCostIsNull, form.parcelType, form.isValueDeclared, form.declaredCargoValue, form.isNoDeclaredValueConfirmation]);

    const changeForm = (name, value) => {
        if (name !== 'declaredCargoValue') {
            if (errors && Array.isArray(value)) {
                let errs = {...errors};
                value.forEach((p, index) => {
                    typeof p === 'object' && Object.keys(p).forEach(pp => {
                        errs[`${name}.${index}.${pp}`] = null;
                    });
                });

                setErrors(errs);
            }

            if (errors && errors[name]) {
                setErrors(errors => ({
                    ...errors,
                    [name]: null
                }))
            }
        }

        setForm(form => ({
            ...form,
            [name]: value
        }));

    };

    const changeParamsForm = (params) => {
        if (errors) {
            let errs = {...errors};
            Object.keys(params).forEach(p => {
                errs[p] = null;
                Array.isArray(params[p]) && params[p].forEach((pp, index) => {
                    typeof pp === 'object' && Object.keys(pp).forEach(ppp => {
                        errs[`${p}.${index}.${ppp}`] = null;
                    });
                })
                params[p] && typeof params[p] === 'object' && Object.keys(params[p]).forEach(pp => {
                    errs[`${p}.${pp}`] = null;
                });
            });

            setErrors(errs);
        }
        setForm(form => ({
            ...form,
            ...params
        }));

    };

    const loadParcelData = (id, isDraft) => {
        return apiGet('parcels/' + id)
            .then(data => {
                data.carrierCostRequests = (isDraft && data.carrierId) ? data.carrierCostRequests : null;
                data.selectedTariff = isDraft ? data.selectedTariff : null;

                data.departureDate = new Date();

                data.deliveryType = data.deliveryTypeCode;

                data.shipmentCity = data.shipmentAddress;
                data.shipmentCountryCode = data.shipmentAddress && data.shipmentAddress.countryCode;

                data.deliveryCity = data.deliveryAddress;
                data.deliveryCountryCode = data.deliveryAddress && data.deliveryAddress.countryCode;

                data.shipmentContactPersonName = data.senderName;
                data.shipmentPhoneNumber = data.senderContactInfo;
                data.shipmentCompany = data.senderCompanyName;
                data.shipmentAdditional = data.senderAdditional;

                data.deliveryPhoneNumber = data.recipientContactInfo;
                data.deliveryContactPersonName = data.recipientName;
                data.deliveryCompany = data.recipientCompanyName;
                data.deliveryAdditional = data.recipientAdditional;

                data.cargoPackages = (data.parcelType === parcelTypes.parcelTypePallets) ? data.palletsCount : data.packagesCount;
                if (data.parcelType === parcelTypes.parcelTypeDoc) {
                    data.documentVolume = data.volume;
                    data.documentWeight = data.weight;
                } else if (data.parcelType === parcelTypes.parcelTypePallets) {
                    data.cargoVolume = data.palletsVolume;
                    data.cargoWeight = data.palletsWeight;
                } else {
                    data.cargoVolume = data.volume;
                    data.cargoWeight = data.weight;
                }

                if (data.positions && data.positions.length > 0) {
                    data.positions.forEach((val, ind, arr) => {
                        val.cargoPackages = val.packagesCount;
                    });
                    setCalcByPlacesOn(true);
                } else data.positions = null;

                setCompanyId(data.companyId);

                data.isCopy = true;
                data.click = true;

                setForm(data);
            })
            .catch(err => {
                console.log(err)
            });
    }

    useEffect(() => {
        if (copyId || draftId) {
            loadParcelData(copyId || draftId, !!draftId);
            onBeforeUnloadOn();
        } else getLastCountries()
        return () => onBeforeUnloadOff();
    }, []);

    useEffect(() => {
        //автооткрытие на этапе поиска тарифов после получения данных из копируемой посылки
        if ((copyId || draftId) && form.click) {
            setForm(form => {
                delete form.click;
                form.deliveryType = form.deliveryType || (deliveryTypes[0] || {}).value;
                return form;
            });
            onPickUp(true, () => setStep(form.parcelType));
        }
    }, [form.click]);

    useEffect(() => {
        if (!form.isCopy) {
            changeForm('cargoDescription', form.parcelType === parcelTypes.parcelTypeDoc ? 'документы' : null);
        }
    }, [form.parcelType])

    const resetData = () => {
        setConfirmModal({
            open: true,
            label: 'Изменение данных',
            children: 'Вы уверены, что хотите изменить данные по заявке?\n Это приведет к отмене выбранного тарифа.',
            onConfirm: () => {
                setTariffs(null);
                setStep(form.parcelType);
            }
        })
    }

    const getCostModel = (isCalc) => {
        const isPallets = form.parcelType === parcelTypes.parcelTypePallets;
        let shipmentAddress = {
            ...form.shipmentAddress,
            postalCode: form.shipmentAddress.postalCode || form.shipmentAddress.estimatedPostalCode
        };
        let deliveryAddress = {
            ...form.deliveryAddress,
            postalCode: form.deliveryAddress.postalCode || form.deliveryAddress.estimatedPostalCode
        };
        if (isCalc) {
            return {
                onlyCompleteCosts: true,
                hideNames: true,
                from: shipmentAddress,
                to: deliveryAddress,
                take: 3,
                parcelType: isPallets ? parcelTypes.parcelTypeCargo : form.parcelType,
                documentWeight: form.documentWeight,
                weight: isPallets ? form.palletsWeight : form.cargoWeight,
                volume: isPallets ? form.palletsVolume : (form.parcelType === parcelTypes.parcelTypeCargo ? form.cargoVolume : form.documentVolume),
                packages: isPallets ? form.palletsCount : form.cargoPackages
            }
        }

        let positions = form.parcelType !== parcelTypes.parcelTypeDoc
            ? (form.positions || []).map((entry) => ({
                weight: entry.weight,
                length: entry.length,
                width: entry.width,
                height: entry.height,
                packagesCount: entry.cargoPackages
            }))
            : null;
        return {
            onlyCompleteCosts: true,
            companyId: companyId,
            subCompanyId: subCompanyId,
            // shipmentCity: form.shipmentCity,
            // deliveryCity: form.deliveryCity,
            shipmentAddress,
            deliveryAddress,
            parcelType: form.parcelType,
            weight: form.parcelType === parcelTypes.parcelTypeDoc ? form.documentWeight : form.cargoWeight,
            volume: form.parcelType === parcelTypes.parcelTypeCargo ? form.cargoVolume : form.documentVolume,
            packagesCount: form.cargoPackages,
            positions,
            departureDate: form.departureDate ? moment(form.departureDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            senderContactInfo: form.shipmentPhoneNumber ? form.shipmentPhoneNumber : null,
            recipientContactInfo: form.deliveryPhoneNumber ? form.deliveryPhoneNumber : null,
            senderAdditional: form.shipmentAdditional ? form.shipmentAdditional : null,
            recipientAdditional: form.deliveryAdditional ? form.deliveryAdditional : null,
        };
    }

    const reloadReferences = () => {
        let loadTypes = apiGet('ref/parceltypes/list')
            .then(data => {

                let parcelTypeDoc = 0;
                let parcelTypeCargo = 0;
                data.entries.map((entry, ind, array) => {
                    if (entry.name === "Document") {
                        parcelTypeDoc = entry.id;
                    } else if (entry.name === "Cargo") {
                        parcelTypeCargo = entry.id;
                    }
                });

                setParcelTypes(data => ({
                    ...data,
                    parcelTypeDoc,
                    parcelTypeCargo
                }))
            })
            .catch(err => {
                console.log(err)
            });

        let loadDeliveryTypes = apiGet('ref/deliverytypes/list/')
            .then(data => {

                    setDeliveryTypes(prevState => {
                        prevState = data.entries.map((entry, ind, array) => {
                            if (entry.isDefault) {
                                changeForm('deliveryType', entry.code);
                            }
                            return {
                                value: entry.code,
                                label: entry.name,
                                isDefault: entry.isDefault,
                                hasIntegration: entry.hasIntegration
                            };
                        });
                        return prevState;
                    });

                }
            )
            .catch(err => {
                console.log(err)
            });

        let loadServices = apiGet('ref/carrierServices/list/')
            .then(data => {
                    data.entries && setServices(data.entries.map(e => ({
                        value: e.code,
                        name: e.name,
                        info: e.description
                    })));
                }
            )
            .catch(err => {
                console.log(err)
            });

        return Promise.all([
            loadTypes, loadDeliveryTypes, loadServices
        ]);
    }

    const loadTariffs = (syncState) => {
        changeForm('saveDisabled', false);
        let result = [];
        let requestData = getCostModel(isCalc);
        return new Promise((resolve, reject) => {
            apiGet(!isCalc ? 'parcels/cost/carriers/' + companyId : `carriers/calc/list/?v=${isCalcV2 ? '2' : '1'}`)
                .then(response => {
                    if (response.entries) {
                        let loadingCount = 0;
                        response.entries.forEach((entry, ind, arr) => {
                            if (entry.hasIntegration) {
                                ++loadingCount;
                                apiPost((!isCalc ? 'parcels/cost/calc/' : 'carriers/calc/costs/') + entry.id + (isCalc ? `?v=${isCalcV2 ? '2' : '1'}` : ''), requestData)
                                    .then(response => {
                                        --loadingCount;
                                        if (!isCalc) {
                                            if (response.costs) {
                                                result = result.concat(response.costs);
                                                result.sort((a, b) => a.cost - b.cost);
                                                if (syncState) {
                                                    setTariffs(result);
                                                }
                                            }
                                        } else {
                                            if (response.tariffs) {
                                                result = result.concat(response.tariffs);
                                                result.sort((a, b) => a.cost - b.cost);
                                                setTariffs(result.map(r => ({...r, displayData: r})));
                                            }
                                        }
                                        if (loadingCount === 0) {
                                            resolve(result);
                                        }
                                    })
                                    .catch(err => {
                                        --loadingCount;
                                        if (loadingCount === 0) {
                                            resolve(result);
                                        }
                                    });
                            }
                        });
                        if (loadingCount === 0) {
                            resolve(result);
                        }
                    } else {
                        resolve(result);
                    }
                })
                .catch(err => reject(err));
        });
    }

    const validateForm = () => {
        let errors = {};

        if ((step === parcelTypes.parcelTypeCargo || step === parcelTypes.parcelTypeDoc || step === parcelTypes.parcelTypePallets) && !(form.shipmentAddress || {}).fullName || !(form.deliveryAddress || {}).fullName) {
            const textError = `Пожалуйста, укажите адрес ${!(form.shipmentAddress || {}).fullName ? 'отправления' : 'доставки'}`;
            toast.error(textError);
            errors[!(form.shipmentAddress || {}).fullName ? 'shipmentAddress' : 'deliveryAddress'] = textError;
        }

        if ((step === parcelTypes.parcelTypeCargo || step === parcelTypes.parcelTypeDoc) && ((form.shipmentAddress || {}).fullName
                && (!(form.shipmentAddress || {}).postalCode && !(form.shipmentAddress || {}).estimatedPostalCode))
            || ((form.deliveryAddress || {}).fullName && (!(form.deliveryAddress || {}).postalCode && !(form.deliveryAddress || {}).estimatedPostalCode))) {
            errors[(form.shipmentAddress || {}).fullName && (!(form.shipmentAddress || {}).postalCode && !(form.shipmentAddress || {}).estimatedPostalCode)
                ? 'shipmentAddress' : 'deliveryAddress'] = postalCodeErrorText;
            toast.error(postalCodeErrorText)
        }

        if (step === parcelTypes.parcelTypePallets) {
            if (!form.palletsVolume) {
                errors['palletsVolume'] = 'Не введен объем';
            }
            if (!form.palletsWeight) {
                errors['palletsWeight'] = 'Не введен вес';
            }
            if (!form.palletsCount) {
                errors['palletsCount'] = 'Не введено кол-во паллет';
            }
            if (!form.cargoDescription || form.cargoDescription.trim() === '') {
                errors['cargoDescription'] = 'Не введено описание содержимого';
            }
        }

        if (step === parcelTypes.parcelTypeCargo || (form.parcelType === parcelTypes.parcelTypeCargo && step === 4)) {

            const errorTotalVolumeAndWeight = !form.cargoVolume || !form.cargoWeight || !form.cargoPackages || !form.cargoDescription;
            const errorCalcByPlaces = !form.positions || (form.positions && !!form.positions.find(pos => !pos.cargoPackages || !pos.width || !pos.weight || !pos.length || !pos.height));

            if (errorTotalVolumeAndWeight && errorCalcByPlaces) {
                if (!form.cargoVolume) {
                    errors['cargoVolume'] = 'Не введен объем';
                }
                if (!form.cargoWeight) {
                    errors['cargoWeight'] = 'Не введен вес';
                }
                if (!form.cargoPackages) {
                    errors['cargoPackages'] = 'Не введено кол-во мест';
                }
                if (!form.cargoDescription || form.cargoDescription.trim() === '') {
                    errors['cargoDescription'] = 'Не введено описание содержимого';
                }

                if (form.positions) {
                    form.positions.forEach((pos, index) => {
                        if (!pos.height) errors[`positions.${index}.height`] = 'Не введено height';
                        if (!pos.length) errors[`positions.${index}.length`] = 'Не введено length';
                        if (!pos.weight) errors[`positions.${index}.weight`] = 'Не введено weight';
                        if (!pos.width) errors[`positions.${index}.width`] = 'Не введено width';
                        if (!pos.cargoPackages) errors[`positions.${index}.cargoPackages`] = 'Не введено cargoPackages';
                    })
                }
            }
        }

        if (step === parcelTypes.parcelTypeDoc || (form.parcelType === parcelTypes.parcelTypeDoc && step === 4)) {
            if (!form.documentWeight) {
                errors['documentWeight'] = 'Не введен вес';
            }
            if (!form.cargoDescription || form.cargoDescription.trim() === '') {
                errors['cargoDescription'] = 'Не введено описание содержимого';
            }
        }

        if (step === 4) {

            if (payerTabErrors) errors = {...errors, ...(payerTabErrors || {})}

            if (!form.shipmentAddress || (form.shipmentAddress && !form.shipmentAddress.city)) {
                errors['shipmentAddress.city'] = 'Не введен населенный пункт отправления';
            }
            if (form.shipmentAddress && (((!form.shipmentAddress.street || !form.shipmentAddress.house) && !form.shipmentAddress.postalCode)
                || (!form.shipmentAddress.street && !form.shipmentAddress.house && form.shipmentAddress.postalCode))) {
                if ((!form.shipmentAddress.street && !form.shipmentAddress.postalCode) || form.shipmentAddress.postalCode) errors['shipmentAddress.street'] = 'Не введена улица в населенном пункте отправления';
                if (form.shipmentAddress.street && !form.shipmentAddress.postalCode) errors['shipmentAddress.house'] = 'Не введен дом в населенном пункте отправления';
            }
            if (form.deliveryAddress && (((!form.deliveryAddress.street || !form.deliveryAddress.house) && !form.deliveryAddress.postalCode)
                || (!form.deliveryAddress.street && !form.deliveryAddress.house && form.deliveryAddress.postalCode))) {
                if ((!form.deliveryAddress.street && !form.deliveryAddress.postalCode) || form.deliveryAddress.postalCode) errors['deliveryAddress.street'] = 'Не введена улица в населенном пункте доставки';
                if (form.deliveryAddress.street && !form.deliveryAddress.postalCode) errors['deliveryAddress.house'] = 'Не введен дом в населенном пункте доставки';
            }
            if (!form.deliveryAddress || (form.deliveryAddress && !form.deliveryAddress.city)) {
                errors['deliveryAddress.city'] = 'Не введен населенный пункт доставки';
            }
            if (!form.shipmentContactPersonName) {
                errors['shipmentContactPersonName'] = 'Не введено контактное лицо отправления';
            }
            if (!form.deliveryContactPersonName) {
                errors['deliveryContactPersonName'] = 'Не введено контактное лицо доставки';
            }
            if (!form.shipmentPhoneNumber || findPhoneNumbersInText(form.shipmentPhoneNumber).length === 0) {
                errors['shipmentPhoneNumber'] = 'Не введен телефон отправления';
            }
            if (!form.deliveryPhoneNumber || findPhoneNumbersInText(form.deliveryPhoneNumber).length === 0) {
                errors['deliveryPhoneNumber'] = 'Не введен телефон доставки';
            }
            if (form.isValueDeclared && !form.declaredCargoValue) {
                errors['declaredCargoValue'] = 'Не введена сумма страхования';
            }
            if (form.selectedTariff && form.selectedTariff.isRecipientCompanyRequired) {
                if (!form.recipientInn) {
                    errors['recipientInn'] = 'Не введен ИНН получателя';
                }
                if (!form.deliveryCompany) {
                    errors['deliveryCompany'] = 'Не введено юр.лицо получателя';
                }
            }
            if (form.selectedTariff && ['CDEK'].includes(form.selectedTariff.carrierCode)) {
                const message = 'Проверьте корректность внесения телефона. Правильный формат: +79991234567. Добавочный номер требуется внести в поле "Добавочный"'
                if (form.shipmentPhoneNumber && containsAnyLetter(form.shipmentPhoneNumber)) {
                    errors['shipmentPhoneNumber'] = 'Телефон некорректен';
                    errors.messageText = message;
                }
                if (form.deliveryPhoneNumber && containsAnyLetter(form.deliveryPhoneNumber)) {
                    errors['deliveryPhoneNumber'] = 'Телефон некорректен';
                    errors.messageText = message;
                }
            }
        }

        return Object.keys(errors).length > 0 ? errors : null;
    }

    const getParcelModel = (isReadyToSend = true) => {
        let currentUserId = getCurrentUserId();
        let positions = form.parcelType === parcelTypes.parcelTypeCargo ? (form.positions || []).map((entry) => ({
            weight: entry.weight,
            length: entry.length,
            width: entry.width,
            height: entry.height,
            packagesCount: entry.cargoPackages
        })) : null;
        return {
            cargoDescription: form.cargoDescription,
            carrierId: form.selectedTariff && form.selectedTariff.carrierId,
            deliveryTypeCode: form.deliveryType,
            deliveryType: form.deliveryType,
            deliveryTime: null,
            departureDate: form.departureDate ? moment(form.departureDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            //isDeliveryTimeSpecified: false,
            //isLoadingRequested: false,
            //isPackagingRequested: false,
            //packagingComment: "",
            //isProductSending: false,
            //isReturnRequested: false,
            isValueDeclared: form.isValueDeclared,
            // isTempConditionRequested: false,
            parcelType: form.parcelType,
            // senderComment: "",
            tempConditionHigh: form.tempConditionHigh,
            tempConditionLow: form.tempConditionLow,
            deliveryCost: form.selectedTariff && (form.selectedTariff.cost + (form.selectedTariff.serviceFe || 0)),
            rawDeliveryCost: form.selectedTariff && (form.selectedTariff.rawCost + (form.selectedTariff.serviceFe || 0)),
            // costPrice: null,
            tariffRate: form.tariffRate,
            // externalNumber: '',
            declaredCargoValue: form.declaredCargoValue,
            // actualDeliveryCost: null,
            carrierServiceCode: form.selectedTariff && form.selectedTariff.carrierServiceCode,
            vehicleTypeId: form.vehicleTypeId,
            packagesCount: form.cargoPackages,
            volume: form.parcelType === parcelTypes.parcelTypeCargo ? form.cargoVolume : form.documentVolume,
            weight: form.parcelType === parcelTypes.parcelTypeDoc ? form.documentWeight : form.cargoWeight,
            volumeWeight: calcWeight(form),

            shipmentAddressId: form.shipmentAddress && form.shipmentAddress.id,
            shipmentAddress: form.shipmentAddress,
            shipmentCityId: form.shipmentCity && form.shipmentCity.id,
            shipmentAddressComment: form.shipmentAddressComment,

            deliveryAddressId: form.deliveryAddress && form.deliveryAddress.id,
            deliveryCityId: form.deliveryCity && form.deliveryCity.id,
            deliveryAddress: form.deliveryAddress,
            deliveryAddressComment: form.deliveryAddressComment,
            // senderId: null,
            senderName: form.shipmentContactPersonName,
            senderContactInfo: form.shipmentPhoneNumber ? form.shipmentPhoneNumber : null,
            senderAdditional: form.shipmentAdditional ? form.shipmentAdditional : null,
            senderCompanyName: form.shipmentCompany,
            // recipientUserId: null,
            recipientContactInfo: form.deliveryPhoneNumber ? form.deliveryPhoneNumber : null,
            recipientAdditional: form.deliveryAdditional ? form.deliveryAdditional : null,
            recipientInn: form.recipientInn,
            recipientName: form.deliveryContactPersonName,
            recipientCompanyName: form.deliveryCompany,
            // shipmentPointContactInfoId: null,
            // deliveryPointContactInfoId: null,
            companyId,
            subCompanyId: form.subCompanyId || subCompanyId,
            // shipmentTypeId: null,
            // shipmentPurposeId: null,
            // productId: null,
            // regionId: null,
            // costCenterId: null,
            // glAccountId: null,
            // userCompanyId: null,
            isReadyToSend,
            carrierCostRequests: !tariffs ? form.carrierCostRequests : tariffs.map(t => ({
                carrierId: t.carrierId,
                carrierServiceCode: t.carrierServiceCode,
                carrierServiceName: t.carrierServiceName,
                cost: t.cost,
                rawCost: t.rawCost,
                tariffRate: t.tariffRate,
                departureDate: t.departureDate,
                minDeliveryTime: t.minDeliveryTime,
                maxDeliveryTime: t.maxDeliveryTime,
                deliveryTimeComment: t.deliveryTimeComment,
                status: t.status,
                statusComment: t.statusComment,
                isSelected: (form.selectedTariff || {}).carrierServiceCode === t.carrierServiceCode && form.selectedTariff.carrierId === t.carrierId,
                claimId: t.claimId,
                version: t.version,
                tariff: t.tariff
            })),
            // claimId: null,
            // version: null,
            // isExternal: true,
            // isConfirmed: false,
            insuranceCost: form.insuranceCost,
            serviceFee: form.selectedTariff && form.selectedTariff.serviceFee,
            isNoDeclaredValueConfirmation: form.isNoDeclaredValueConfirmation,
            allStatusNotifications: form.allStatusNotifications,
            positions,
            services: formServicesArray(form),
            source: !!copyId ? 2 : 1,
            draftParcelId: draftId,

            //для блока Плательщик
            initiatorId: form.initiatorId ? form.initiatorId : currentUserId,
            isCrossSector: form.isCrossSector,
            initiatorIsCrossSector: form.initiatorIsCrossSector,
            initiatorSubCompanyId: form.initiatorSubCompanyId,
            shipmentTypeId: form.shipmentTypeId,
            shipmentPurposeId: form.shipmentPurposeId,
            productId: form.productId,
            activityCode: form.activityCode,
            regionId: form.regionId,
            regionCode: form.regionCode,
            costCenterId: form.costCenterId,
            glAccountId: form.glAccountId,
            userCompanyId: form.userCompanyId,
        };
    }

    const formatCost = (value) => {
        if (value) {
            return value.toFixed(2);
        } else {
            return '0.00';
        }
    }

    const saveDraft = () => {
        setLoadingDraftSave(true);
        let parcelData = getParcelModel(false);
        apiPut('parcels/new', parcelData)
            .then(() => {
                setIsSaved(true);
                setLoadingDraftSave(false);
                history.push('/parcels/list');
            })
            .catch(e => {
                console.log(e);
                toast.error('Произошла ошибка')
                setLoadingDraftSave(false)
        });
    }

    const sendParcelRequest = (completeCallback) => {
        let parcelData = getParcelModel();
        parcelData.isConfirmed = true;

        apiPut('parcels/new', parcelData)
            .then(data => {
                let parcelId = data.parcelId;
                completeCallback && completeCallback();

                changeParamsForm({
                    parcelId
                })
                onBeforeUnloadOff();
                setIsSaved(true);
                history.push({
                    pathname: '/parcels/' + parcelId,
                    hash: '#docs',
                }, ['PE', 'CDEK'].includes((form.selectedTariff || {}).carrierCode) ? {
                    info: 'Документы по отправлению будут направлены вам на почту в течение 10 минут'
                } : null);
            })
            .catch(errors => {
                let parcelId = errors.parcelId;
                completeCallback && completeCallback();

                if (errors && errors.validationResult && errors.validationResult.messages) {
                    let errorMessages = errors && errors.validationResult && errors.validationResult.messages;
                    toast.error((Object.keys(errorMessages).map(key => errorMessages[key])).join('; '))
                    setErrors(errorMessages);
                } else {
                    toast.error('Произошла ошибка');
                }
                if (parcelId) {
                    changeParamsForm({
                        parcelId
                    })
                    onBeforeUnloadOff();
                    setIsSaved(true);
                    history.push({
                        pathname: '/parcels/' + parcelId,
                        hash: '#history'
                    });
                }
            });
    }

    const createParcel = () => {
        setLoadingCreate(true);
        let errors = validateForm();
        if (errors) {
            setErrors(errors);
            if (errors.messageText) {
                toast.error(errors.messageText);
            } else {
                toast.error('Заполните все обязательные поля');
            }
            setLoadingCreate(false);
        } else {
            updateTariffData(
                (oldCost, newCost) => {
                    if (oldCost && newCost && oldCost !== newCost) {
                        setConfirmModal({
                            open: true,
                            label: 'Изменение стоимости доставки',
                            children: 'Стоимость доставки изменилась с ' + formatCost(oldCost) + ' на ' + formatCost(newCost) + '. Вы хотите заказать доставку по новой цене?',
                            onConfirm: () => sendParcelRequest(() => setLoadingCreate(false)),
                            onClose: () => {
                                setLoadingCreate(false);
                                setStep(3);
                            }
                        })
                    } else {
                        sendParcelRequest(() => setLoadingCreate(false));
                    }
                },
                () => setLoadingCreate(false)
            );
        }
    }

    const onFindTariffsByCities = () => {
        setLoadingTariffs(true);

        loadTariffs(true)
            .then(() => {
                setLoadingTariffs(false);
            })
            .catch(err => {
                setLoadingTariffs(false);
            });
    }


    const onPickUp = (noLoad, errorCallback) => {
        if (isCalcV2) ym(49255948, 'reachGoal', 'click-tariffs')
        let errs = validateForm();
        if (errs) {
            setErrors(errs);
            errorCallback && errorCallback()
        } else {

            setErrors({});
            setStep(3);
            setTariffs([]);

            !noLoad && onFindTariffsByCities();
        }
    }


    const [weekdays, setWeekdays] = useState([]);

    const postalCodeErrorText = 'Укажите полный адрес';

    const getGates = () => {
        let startDate = new Date();
        let endDate = new Date();
        endDate.setFullYear(endDate.getFullYear() + 1);
        apiPost('ref/dayoffs/list', {
            startDate: moment(startDate).format('YYYY-MM-DD'),
            endDate: moment(endDate).format('YYYY-MM-DD')
        }).then(r => {
            setWeekdays(r.entries)
        })
    }

    useEffect(() => {
        getGates();
        reloadReferences();
    }, [])

    const handleAddressSelect = (name, value, withoutCity) => {
        if (name.includes('parcelType')) {
            changeForm(name, value);
        } else {
            let item = {...value};
            let values = {
                [`${name}Address`]: item,
                [`${name}ContactPersonName`]: item.contactName,
                [`${name}Company`]: item.companyName,
                [`${name}PhoneNumber`]: item.contactPhone,
                [`${name}Additional`]: item.additionalPhone,
                [`${name}AddressComment`]: item.comment
            };

            if (!withoutCity) values[`${name}City`] = item;

            if (item.countryCode) values[`${name}CountryCode`] = item.countryCode;
            changeParamsForm(values);

            const addressError = item.fullName && (!item.postalCode && !item.estimatedPostalCode);
            setErrors(errors => ({
                ...(errors || {}),
                [`${name}Address`]: addressError ? postalCodeErrorText : null
            }));
            addressError && toast.error(postalCodeErrorText);
        }
    }

    const updateTariffData = (callback, callbackFailed) => {
        changeForm('saveDisabled', false);
        if (step === 4) {
            setLoadingTariffs(true);
            const selectedTariff = form.selectedTariff;
            let requestData = getCostModel();

            apiPost('parcels/cost/calc/' + selectedTariff.carrierId, requestData).then(res => {
                const tariffs = res.costs;
                let tariff = tariffs && tariffs.length && tariffs.find(trf => trf.carrierServiceCode === selectedTariff.carrierServiceCode && trf.carrierId === selectedTariff.carrierId);

                if (tariff) {
                    changeForm('selectedTariff', tariff);
                    setLoadingTariffs(false);
                    callback && callback(selectedTariff && selectedTariff.cost, tariff.cost);
                    return true;
                } else {
                    changeForm('saveDisabled', true);
                    toast.error('Для введенных данных отсутствует тариф в выбранной транспортной компании');
                    setLoadingTariffs(false);
                    callbackFailed && callbackFailed();
                    return false;
                }
            }).catch(e => {
                toast.error('Произошла ошибка');
                callbackFailed && callbackFailed();
            })
        }

        return false;
    };

    const saveDraftBtn = <Button
        disabled={loadingDraftSave}
        loading={loadingDraftSave}
        className='modal__btn-cancel m-t-16'
        onClick={() => {
            saveDraft()
        }}
    >
        Сохранить для доработки
    </Button>

    return (
        <div className={`new ${isCalc ? 'new-calc' : ''}`}>
            <Segment className='b-b-0' vertical>
                <Dimmer inverted active={(copyId || draftId) && step === 0} className={'copy-dimmer'}>
                    <Loader label={'Загрузка данных'} description={copyId && 'Идет копирование'}/>
                </Dimmer>
                <Addresses
                    errors={errors || {}}
                    isCalc={isCalc}
                    isCalcV2={isCalcV2}
                    label={step <= 0}
                    form={form}
                    onChange={handleAddressSelect}
                    companyId={companyId}
                    setCompanyId={setCompanyId}
                    parcelTypes={parcelTypes}
                    customBlock={step === -1 && <SetCompanyBlock
                        companyId={companyId}
                        onChange={(value) => {
                            setCompanyId(value);
                            setStep(0);
                        }}
                    />}
                />
            </Segment>
            <Step
                weekdays={weekdays}
                loading={loadingTariffs}
                step={step}
                form={form}
                setStep={setStep}
                changeForm={changeForm}
                changeParams={changeParamsForm}
                onClick={onPickUp}
                tariffs={tariffs}
                deliveryTypes={deliveryTypes}
                companyId={companyId}
                resetData={resetData}
                companyData={companyData}
                onChangeAddress={handleAddressSelect}
                createParcel={createParcel}
                loadingCreate={loadingCreate}
                services={services}
                errors={errors || {}}
                parcelTypes={parcelTypes}
                isCalc={isCalc}
                isCalcV2={isCalcV2}
                calcByPlacesOn={calcByPlacesOn}
                setCalcByPlacesOn={setCalcByPlacesOn}
                saveDraftBtn={!isCalc && saveDraftBtn}
                setErrors={(errors) => setPayerTabErrors(errors)}
                initData={initForm}
                getValueDeclaredDisabled={getValueDeclaredDisabled}
                insuranceCostIsNull={insuranceCostIsNull}
            />
            {confirmModal && <ConfirmModal
                open={confirmModal.open}
                label={confirmModal.label}
                setOpen={() => setConfirmModal(null)}
                onConfirm={confirmModal.onConfirm}
                onClose={confirmModal.onClose}
                children={confirmModal.children}
            />}
            <Prompt when={!!draftId && (step > 3) && !isSaved}
                    message="Вы действительно хотите перейти? Введенная вами информация не будет сохранена."
            />
        </div>
    );
};

export default CreateParcelForm;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/createParcelForm.jsx